// @ts-nocheck
import React from 'react'
import styles from './CardTable.module.scss'
import { CardTableHeaderCell } from './CardTableHeaderCell'
import { Checkbox } from 'components/shared/FormFields/common/Checkbox/Checkbox'
import { CHECKBOX_CELL_WIDTH, CLOSE_CELL_WIDTH } from './constants'
import { t } from 'ttag'

export const CardTableHeader = ({
  children,
  withCheckbox,
  toggleSelectAll,
  withClose,
  checkboxLabel = t`Select all`,
  selected = false,
}) => {
  const ref = React.useRef(null)

  return (
    <tr className={styles.cardTableHeaderContainer}>
      {children}
      {withCheckbox ? (
        <CardTableHeaderCell
          width={CHECKBOX_CELL_WIDTH}
          className={styles.justifyRight}
        >
          {checkboxLabel}{' '}
          <Checkbox value={selected} onChange={toggleSelectAll} ref={ref} />
        </CardTableHeaderCell>
      ) : null}
      {withClose ? (
        <CardTableHeaderCell
          width={CLOSE_CELL_WIDTH}
          className={styles.justifyRight}
        ></CardTableHeaderCell>
      ) : null}
    </tr>
  )
}
